export enum ControlType {
  Multi = 'multi',
  String = 'string',
  Number = 'number',
}
